import React, { useState } from "react";
import { Row, Col, Container, Button, Alert } from "reactstrap";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import withRouter from "../../components/Common/withRouter";
import { useTranslation } from "react-i18next";
import { forgotPassword, loginAction } from "src/store/auth/saga";
import { useAppSelector } from "src/store";
import avatar1 from "../../assets/images/logo-sm.svg";
import { Formik } from "formik";
import * as Yup from "yup";
import "./style.scss";
import GetInput from "src/components/Form/GetInput";
import { setUser } from "src/store/auth/authSlice";
import { getLanguages } from "src/store/languages/saga";
import { useNavigate } from "react-router";
import Loader from "src/components/Loader";
import { toast } from "react-toastify";
import Layout from "./Layout";

const ForgetPassword = (props: any) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loader = useAppSelector((s) => s.loading.loading);
  const [error, setError] = useState<string>();
  const [msg, setmsg] = useState<string>();
  const navigate = useNavigate();
  const a = localStorage.getItem("language");
  return (
    <React.Fragment>
      <Layout
        title={t("ForgotPassword.Title").toString()}
        subtitle={t(
          "ForgotPassword.Sub",
          "Şifreni sıfırlamak için e-posta adresini gir"
        ).toString()}
      >
        {loader && <Loader />}
              <Formik
                initialValues={{
                  Email: "goncanur@komut.team",
                  Password: "1q2w3E*",
                }}
                onSubmit={(values) => {
                  dispatch(
                    forgotPassword({
                      payload: {
                        onSuccess: (message, payload) => {
                          setmsg(message);
                          setTimeout(() => {
                            navigate("/login");
                          }, 2000);
                        },
                        onError: (message) => {
                          setError(message);
                        },
                      },
                      body: values,
                    })
                  );
                }}
                validationSchema={Yup.object().shape({
                  Email: Yup.string()
                    .required(t("Validation.Required").toString())
                    .email(t("Validation.Email").toString()),
                })}
              >
                {({ handleSubmit }) => (
                  <Row className="mt-4">
                    {error && (
                      <Col md={12}>
                        <Alert color="danger">{error}</Alert>
                      </Col>
                    )}
                    {msg && (
                      <Col md={12}>
                        <Alert color="success">{msg}</Alert>
                      </Col>
                    )}
                    <GetInput
                      inputprop={{
                        field: "Email",
                        label: t("Authentication.Email").toString(),
                        type: "email",
                      }}
                    />
                    <Col md={12}>
                      <Button
                        className="w-100"
                        color="success"
                        type="submit"
                        style={{ fontSize: 12 }}
                        onClick={() => handleSubmit()}
                      >
                        {t("ForgotPassword.Button")}
                      </Button>
                    </Col>
                  </Row>
                )}
              </Formik>
      </Layout>
    </React.Fragment>
  );
};

export default withRouter(ForgetPassword);
ForgetPassword.propTypes = {
  history: PropTypes.object,
};
